module.exports = window.dnn.nodeModules.ReduxDevTools;